export default "__VITE_ASSET__efb820b3__"